export default __webpack_public_path__ + "static/paloalto-5c6733558a98dcc5b54414ecda25054a.png";